<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/appprotecttmobileappsecurity",
		    "name": "AppProtectt Mobile APP Security"
		  }
		}		]
	}
	</script>

<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>AppProtectt Mobile APP Security</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<!-- Start Introduction -->
<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/app_security_banner.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
    <div class="container subbanner position-relative">
        <a href="javascript://" class="play-button" style="background: url('assets/images/header/play_button.webp')"
            data-toggle="modal" data-target="#playLandingVideo"
            (click)="onClickPdfView('video/Protectt Ai 13FEB f_fff.mp4')"></a>
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
                    <h1 id="bnr-heading">{{heading}} </h1>
                    <h2 id="bnr-subheading">{{subheading}}</h2>
                    <a class="btn-rectangle btn-transparent btn" (click)="goto()">Request A Demo</a>
                    <!-- <a class="btn-rectangle btn-transparent btn" href="mailto:sales@protectt.ai">Get In Touch</a> -->
                    <!-- <a class="btn-rectangle btn-transparent btn" (click)="goto()">Request A Demo</a> -->
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/app_security_banner.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner position-relative">
        <a href="javascript://" class="play-button" style="background: url('assets/images/header/play_button.webp')"
            data-toggle="modal" data-target="#playLandingVideo"
            (click)="onClickPdfView('video/Protectt Ai 13FEB f_fff.mp4')"></a>
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                    <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
                <!-- <a class="btn-rectangle btn-transparent btn" href="mailto:sales@protectt.ai">Get In Touch</a> -->
                <!-- <a class="btn-rectangle btn-transparent btn" (click)="goto()">Request A Demo</a> -->
            </div>
        </div>
    </div>
</div>
<!-- End Introduction -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray pt-4 section-pb-60">
    <div class="container d-flex">
        <div class="row">
            <div class="col-lg-6">
                <img src="assets/images/app-protectt/app-protectt_m.webp" class="og_image_url"
                    alt="Mobile Banking Application Security for Dgital Payments">
            </div>
            <div class="col-lg-6">
                <div class="agency-benefits">
                    <div class="content">
                        <p>As mobile app usage continues to soar the dynamic nature of mobile app development is
                            presenting
                            unique security challenges requiring businesses to adopt innovative approaches to protect
                            against
                            the latest mobile app security threats.</p>
                        <p>Mobile App Security is no more an option, but it is an obligation. A surge in Mobile App
                            Usage
                            creates multiple benefits such as better customer experience and convenience, on the other
                            hand it
                            has become a lucrative playground for fraudsters. Runtime Application Self Protection (RASP)
                            technology has revolutionised mobile app security and is the need of the hour. It ensures
                            run-time
                            protection by detecting and mitigating threats while the app is running.</p>
                        <p>AppProtectt - Protectt.ai’s state-of-the-art RASP Mobile App Security solution is powered by
                            Artificial
                            Intelligence and Behavioural Science on our innovative Security Cloud. AppProtectt is
                            compliant with
                            the “RBI Digital Payment Security Control Guidelines”. This lightweight and
                            easy-to-integrate SDK
                            offers advanced Device Binding, Unsecured Wi-Fi security check, Anti-Screen Mirroring and
                            Sharing,
                            Anti-Malware, and prevention from MiTM, Tampering, and Reverse Engineering. AppProtectt is
                            compatible with native iOS, Android, and Hybrid Apps.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Agency Benefits Area -->


<div class="section-agency-benefit section-pt-60 section-pb-60" id="targetcontact">
    <div class="container d-flex">
        <div class="row">
            <div class="col-lg-6">
                <h4 class="modal-title w-100 font-weight-bold">
                    Get a quick demo with our expert
                </h4>
                <div>
                    <p class="formparagraph1 text-left mrgntop-20">
                        AppProtectt is trusted by leading enterprises across the banking, finance, healthcare, and
                        government
                        sectors for comprehensive Mobile App Security solution. To get a demo, fill
                        out the form below.
                    </p>
                </div>
                <div class="mt-2">
                    <form [formGroup]="demoForm" class="contactusform pt-1 pb-3">
                        <div class="row">

                            <div class="md-form mb-20 col-6">
                                <label class="mb-0" data-error="wrong" data-success="right" for="form34">Name <span class="text-danger">*</span></label>
                                <input type="text" placeholder="Enter Your Name" id="form34"
                                    class="form-control validate input" formControlName="name" name="name"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                                    <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                                    <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid name</div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-6">
                                <label class="mb-0" data-error="wrong" data-success="right" for="form34">Work Email <span class="text-danger">*</span></label>
                                <input type="email" placeholder="Enter Your Work Email " formControlName="email"
                                    class="form-control input" id="email" name="email"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                                    <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                                    <div *ngIf="getDemoForm.email.errors.isValidEmail">* Plaese enter business email
                                    </div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-6">
                                <label class="mb-0" data-error="wrong" data-success="right" for="form34">Phone
                                    Number <span class="text-danger">*</span></label>
                                <input type="text" placeholder="Enter Your Phone Number" id="form34"
                                    class="form-control validate input" formControlName="contactnumber"
                                    name="contactnumber"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required
                                    </div>
                                    <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please, Enter 10 digit
                                        Mobile
                                        Number.
                                    </div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-6">
                                <label class="mb-0" data-error="wrong" data-success="right"
                                    for="form34">Company <span class="text-danger">*</span></label>
                                <input type="text" placeholder="Enter Your Company Name" id="form34"
                                    class="form-control validate input" formControlName="company_name"
                                    name="company_name"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.company_name.errors.required">* This field is required</div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-12">
                                <label class="mb-0" data-error="wrong" data-success="right"
                                    for="form34">Designation <span class="text-danger">*</span></label>
                                <input type="text" placeholder="Enter Your Designation" id="form34"
                                    class="form-control validate input" formControlName="designation" name="designation"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                                    <div *ngIf="getDemoForm.designation.errors.maxlength">* Please enter valid name
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <button class="btn btn-unique ml-3" id="closeModal"
                                (click)="submitDemoForm()">GET A DEMO</button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="agency-benefits">
                    <div class="content">
                        <h4 class="modal-title w-100 font-weight-bold">What to expect from our demo?</h4>
                        <p>Our experts will help you navigate through your mobile app security challenges and help secure your
                            application seamlessly.</p>
                        <ul style="list-style-type: square; padding-left: 30px;">
                            <li>Securing mobile application from ever-evolving cyber threats with Runtime Application Self-
                                Protection (RASP)</li>
                            <li>Seamless integration of AppProtectt SDK into your app</li>
                            <li>Learn how you can comply with regulatory compliances and guidelines</li>
                            <li>How to protect critical Mobile Apps from:</li>
                            <ul style="list-style-type: circle; padding-left: 30px;">
                                <li>Reverse Engineering</li>
                                <li>App Tampering</li>
                                <li>App Spoofing</li>
                                <li>Screen Mirroring</li>
                                <li>Malware/ Trojans</li>
                                <li>MiTM attacks</li>
                                <li>Unsecured Wi-Fi</li>
                            </ul>
                            <li>Sample fraud case scenarios</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<section class="wrapper-card">
    <div class="container">
        <div class="content">
            <div class="container appprotecttcard">
                <div class="row mt-30">
                    <div class="col-lg-12">
                        <div class="section-title text-center">
                            <h2>Comprehensive In-App Protection</h2>
                        </div>
                        <p class="mt-20" style="text-align: center;">
                            AppProtectt offers innovative Runtime Application Self Protection (RASP) that is automated,
                            intelligent and self-defending and proven to keep you safe from:
                        </p>
                    </div>
                </div>
                <!-- 1st row -->
                <div class="row mt-30">

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body text-center">
                                <ul>
                                    <li><span class="material-icons">code_off</span></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Debugging</h6>
                                <p class="card-text text-center">AppProtectt adds anti-debugging protection to your
                                    meticulously developed<span class="debugging dots">...</span><span
                                        class="more debugging"> app that
                                        secures it from debugging tools that may attempt to read your source code. It
                                        blocks
                                        native and Java debugging tools from attaching to your iOS or Android app and
                                        actively detects any dynamic injection code manipulations performed during
                                        run-time.</span>
                                </p>
                                <a (click)="myFunction('debugging')" id="debugging-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body text-center">
                                <ul>
                                    <li><span class="material-icons">mobile_screen_share</span></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Spoofing</h6>
                                <p class="card-text text-center">Mobile apps are susceptible to sophisticated spoofing
                                    attacks which allow other<span class="spoofing dots">...</span><span
                                        class="more spoofing"> apps
                                        to assume the identity of the original app. Hackers exploit this technique to
                                        gain
                                        control of users’ sensitive login information or transactional details.
                                        AppProtectt
                                        prevents a malicious app from gaining control and detects whether any app
                                        installed
                                        is harmful to your business application.</span></p>
                                <a (click)="myFunction('spoofing')" id="spoofing-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body text-center">
                                <ul>
                                    <li><span class="material-icons">sync_lock</span></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">End to End Encryption</h6>
                                <p class="card-text text-center">AppProtectt’s advanced encryption standards protect
                                    your iOS or Android app<span class="endtoend dots">...</span><span
                                        class="more endtoend"> by
                                        enabling robust data protection and preventing any breaches or malicious
                                        infiltrations. Secure your app with unique encryption using dynamic in-app,
                                        app-specific cryptography and threat aware encryption keys. AppProtectt
                                        encryption
                                        is optimised for powerful performance at encryption and decryption ensuring a
                                        smooth
                                        user experience.</span></p>
                                <a (click)="myFunction('endtoend')" id="endtoend-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>

                    <!-- 2nd row -->

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body text-center">
                                <ul>
                                    <li><span class="material-icons">handyman</span></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Reverse Engineering</h6>
                                <p class="card-text text-center">Reverse Engineering allows hackers to analyse a
                                    compiled app and
                                    extract<span class="reverse dots">...</span><span class="more reverse"> information
                                        about its source code. They can then leverage the source code to
                                        execute an attack, access proprietary information, expose vulnerabilities
                                        or repack and redistribute a malicious version to a targeted victim. Your source
                                        code is
                                        at the core of your business operations and AppProtectt acts as the first line
                                        of
                                        defence in safeguarding it against threats.</span></p>
                                <a (click)="myFunction('reverse')" id="reverse-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body text-center">
                                <ul>
                                    <li><span class="material-icons">offline_share</span></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Screen Mirroring</h6>
                                <p class="card-text text-center">Screen mirroring can allow attackers to visually see
                                    the credentials an end-user<span class="screen dots">...</span><span
                                        class="more screen"> is
                                        entering without him knowing about it. By monitoring the keystrokes of your end
                                        users’ device screen lock pattern or the passcode of a banking app, attackers
                                        can
                                        easily replicate the existing authentication protocols. AppProtectt’s
                                        proprietary
                                        behaviour analysis can identify any screen mirroring on a user’s device and
                                        alert
                                        them in real-time.</span></p>
                                <a (click)="myFunction('screen')" id="screen-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>

                    <!-- 3rd row -->

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body text-center">
                                <ul>
                                    <li><span class="material-icons">forward_to_inbox</span></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">SMS Attacks</h6>
                                <p class="card-text text-center">With SMS continuing to be the primary mode of
                                    authentication, hackers are<span class="sms dots">...</span><span class="more sms">
                                        always on
                                        the lookout for opportunities to exploit this lesser secure channel of
                                        communication. This malpractice is particularly common in consumer-facing
                                        sectors to
                                        compromise device binding or gain access to OTPs. Protectt.ai’s proprietary
                                        technology helps organisations to prevent threats rising from these exploits
                                        when
                                        authenticating end users.</span></p>
                                <a (click)="myFunction('sms')" id="sms-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body text-center">
                                <ul>
                                    <li><span class="material-icons">webhook</span></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Hooking</h6>
                                <p class="card-text text-center">Hooking is an increasing threat in mobile apps as
                                    hackers attempt to intercept<span class="hooking dots">...</span><span
                                        class="more hooking"> and
                                        manipulate the run-time business logic of your app without the need to access
                                        the
                                        source code. Bypassing the business logic can result in a loss of revenue for
                                        your
                                        organisation and increases the risk for data and financial fraud of your users.
                                        App
                                        Protectt hardens and protects your mobile app and hinders any external tampering
                                        of
                                        your original function logic.</span></p>
                                <a (click)="myFunction('hooking')" id="hooking-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>

                    <!-- 4th row -->

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body text-center">
                                <ul>
                                    <li><span class="material-icons">camera_front</span></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Man-in-the-Middle Attacks</h6>
                                <p class="card-text text-center">In today’s privacy-focused world, the safety of user
                                    data is vital. With the
                                    increasing<span class="mitm dots">...</span><span class="more mitm"> flow of data
                                        between end-users and your app server, Man-in-the-Middle
                                        Attacks try to gain access to and preview information within a secured
                                        communication channel. AppProtectt safeguards your private communications and
                                        sensitive information against such malicious attacks.</span></p>
                                <a (click)="myFunction('mitm')" id="mitm-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row my-3">
            <div class="col-md-12 text-center text-white">
                <a class="btn-rectangle btn-transparent btn" (click)="goto(1)">Request A Demo</a>
            </div>
        </div>
    </div>
</section>

<!-- Start Other Features -->

<!-- End Comprehensive In-App Protection -->

<div class="prestigiouscustomers">
    <div class="fewofcust container">
        <div class="row">
            <div class="col-md-12 text-center section-title mt-30">
                <h4>Few of Our Prestigious Customers</h4>
            </div>
        </div>
        <div class="row mt-30">
            <ul class="prestigiouscustul">

                <li><img class="img-fluid" src="assets/images/new/bsemain.webp" alt="BSE Experience The New">
                </li>
                <li><img class="img-fluid" src="assets/images/new/RBL_Bank.webp" alt="RBL Bank"></li>
                <li><img class="img-fluid" src="assets/images/new/Yes_Bank_logo.webp" alt="YES Bank"></li>
                <li><img class="img-fluid" src="assets/images/new/fincare.webp" alt="Fincare"></li>
                <li><img class="img-fluid" src="assets/images/new/Chola-MS.webp" alt="Chola MS"></li>
                <li><img class="img-fluid" src="assets/images/new/iifl_home.webp" alt="IIFL Home Loan"></li>
                <li><img class="img-fluid" src="assets/images/new/iifl_security.webp" alt="IIFL Securities">
                </li>
                <li><img class="img-fluid" src="assets/images/new/suryoday_logo.webp" alt="SURYODAY"></li>
                <li><img class="img-fluid" src="assets/images/new/fusion_logo.webp" alt="FUSION"></li>
                <li><img class="img-fluid" src="assets/images/new/pharmatica.webp" alt="PRAMERICA"></li>
                <li><img class="img-fluid" src="assets/images/new/ageas_fedral.webp" alt="ageasFEDERAL"></li>
                <li><img class="img-fluid" src="assets/images/new/equitas_logo.webp" alt="Equitas"></li>
                <li><img class="img-fluid" src="assets/images/new/iifl_finance.webp" alt="IIFL Finance"></li>
                <li><img class="img-fluid" src="assets/images/new/india_icc.webp" alt="INDIA ICC"></li>
                <li><img class="img-fluid" src="assets/images/new/india_inx.webp" alt="INDIA INX"></li>
                <li><img class="img-fluid" src="assets/images/new/kinara.webp" alt="KINARA CAPITAL"></li>
                <li><img class="img-fluid" src="assets/images/new/midgate.webp" alt="MINDGATE"></li>
                <li><img class="img-fluid" src="assets/images/new/iccl.webp" alt="ICCL"></li>
                <li><img class="img-fluid" src="assets/images/new/5paisa.webp" alt="5Paisa.com"></li>
                <li><img class="img-fluid" src="assets/images/new/ed_prime.webp" alt="ED PRIME"></li>

            </ul>
        </div>
    </div>
</div>

<div class="section-agency-benefit bg-gray section-pb-60 mt-50">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title text-center">
                    <h2>Why Organisations Choose Us</h2>
                </div>
            </div>
        </div>

        <div class="container w-100 text-center">
            <div class="row justify-content-center">
                <div class="col-md-4">
                    <div class="service-box">
                        <div class="service-icon yellow">
                            <div class="front-content">
                                <img src="assets/images/about-mobile-security/final-icons/1.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-3">Cost-Effective</h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <h3>Cost-Effective</h3>
                            <p>AppProtectt provides an easy-to-install SDK package on a subscription basis with 50+
                                security
                                features and saves resources in developing in-house security capabilities.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="service-box">
                        <div class="service-icon orange">
                            <div class="front-content">
                                <img src="assets/images/about-mobile-security/final-icons/2.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-3">Standardised Security</h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <h3>Standardised Security</h3>
                            <p>Our AI-driven security cloud ensures standardised threat mitigation across all sectors.
                                Get access to
                                the top-of-the-line, enterprise safety software by subscribing to AppProtectt.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="service-box">
                        <div class="service-icon orange">
                            <div class="front-content">
                                <img src="assets/images/about-mobile-security/final-icons/5.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-3">Regulatory Compliance</h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <h3>Regulatory Compliance</h3>
                            <p>AppProtectt ensures up-to-date regulatory compliance for mobile app security. We
                                constantly
                                update security protocols to abide by all the developments in regulations and legal
                                frameworks.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="mt-3 content text-center">
            <a class="btn-rectangle btn-transparent btn" href="mailto:sales@protectt.ai">Get In Touch</a>
        </div> -->
    </div>
</div>

<!-- Start Agency Benefits Area -->
<div class="container section-pb-60">
    <!--  image right  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 order-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/app-protectt/AppProtectt-aio.webp"
                        alt="Secure your Mobile Apps with All in One Mobile App Security " />
                </div>
            </div>
        </div>
        <!-- /.col-md-6 -->
        <div class="col-md-6 order-md-1">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>All In One Mobile App Security</h3>
                    <p>Accelerate your mobile app security infrastructure with AppProtectt. Just like legacy desktop and
                        laptop software, mobile apps need to be secured against malicious attacks, now more than ever
                        before. AppProtectt injects comprehensive,
                        360-degree security that enables Runtime Application Self Protection (RASP) for advanced
                        detection and mitigation of all types of mobile threats - from app tampering to being reverse
                        engineered. We help your organisation offload
                        security concerns enabling you to focus on developing your main business logic.
                    </p>
                </div>
            </div>

        </div>
    </div>

    <!--  image left  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img mt-15">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/app-protectt/AppProtectt-compromised.webp"
                        alt="Mobile Application Security Assessment," />
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Safeguard Your App - Even On Compromised Devices</h3>
                    <p>Traditional cybersecurity tools are focused on fixed endpoints such as the local servers,
                        desktops and laptops. AppProtectt extends this to your user’s mobile device to bridge a gaping
                        hole in your security infrastructure. Smartphones
                        are still a young, a constantly evolving environment that requires modern, dynamic solutions
                        that not only prevent threats but are also equipped with detection and response capabilities. We
                        ensure that your organisation, your app
                        and your users stay protected while respecting the privacy of your data.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!--  image right  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 order-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/app-protectt/AppProtectt-network-security.webp"
                        alt="Best Mobile Network & Application Data Security App" />
                </div>
            </div>
        </div>
        <div class="col-md-6 order-md-1">

            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Zero Trust Network Security</h3>
                    <p>Whether you have a B2B or a B2C mobile app and whether your end users are consumers or your own
                        employees, AppProtectt ensures that you are always in control of app security even when being
                        used outside your control. We secure your
                        app with a zero-trust approach - continuously hunting for malicious attacks and threats even
                        when it is being accessed beyond the perimeter of your legacy network security.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!--  image left  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/app-protectt/AppProtectt-Security-Cloud.webp"
                        alt="Protect your Mobile Applications from Cyber Security" />
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>State-of-the-Art Security Cloud</h3>
                    <p>Protectt.ai Lab’s proprietary Security Cloud leverages the power of Artificial Intelligence and
                        Machine Learning to build Threat Intelligence that detects emerging cyber threats for all our
                        customers. Additionally, cyber security experts
                        at our state-of-the-art Central Intelligence Lab are continuously and meticulously performing
                        threat hunting to analyse these threats and develop defence mechanisms at instantaneous speeds
                        to deliver comprehensive security for
                        your mobile apps.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!--  image right  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 order-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/app-protectt/AppProtectt-dashboard.webp"
                        alt="Best Mobile App Security for Mobile Banking - manage all the threats from one dashboard" />
                </div>
            </div>
        </div>

        <div class="col-md-6 order-md-1">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>A Single Dashboard To Monitor Your Complete Ecosystem</h3>
                    <p>AppProtectt provides a secure, in-depth reporting dashboard that enables your organization to get
                        a bird’s eye view of the threat landscape surrounding your mobile app. Get real-time
                        notification of high-risk events within your ecosystem,
                        identify threats and security measures deployed to mitigate any malicious attacks. We enable the
                        business and security teams to control all security measures by configuring them on the fly.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!--  image left  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/app-protectt/AppProtectt-ota.webp"
                        alt="Updates - Latest Mobile App Security " />
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Over-the-Air Updates - Anywhere, Anytime</h3>
                    <p>With AppProtectt’s SaaS (Security as a Service) model, you get continuous and regular security
                        updates and patches to ensure your mobile app stays updated in a constantly evolving threat
                        landscape. Over-the-Air (OTA) updates help you
                        deliver the latest in mobile app security to your users remotely from anywhere and anytime This
                        innovative approach helps you to patch security fixes without depending on any approvals on your
                        distribution channels.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row align-items-center mt-50">
        <div class="col-12 text-center text-white">
            <a class="btn-rectangle btn-transparent btn" (click)="goto(1)">Request A Demo</a>
        </div>
    </div>
</div>

<section class="mediasection">
    <div class="curve">
    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 section-title text-center">
                <h4 class="mt-40 mrgn">Media</h4>
            </div>
        </div>
        <div class="row bgcolor">
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://www.firstpost.com/business/budget-2024-expectations-will-fm-provide-further-clarity-direction-on-plans-for-digital-rupee-12061072.html"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/first_post.webp"
                                alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent">
                            <h6>Budget 2024 Expectations: Will FM provide further clarity, direction on plans for
                                digital rupee? </h6>
                            <!-- <p class="newsdate">sep 20, 2022</p> -->
                            <p>With Union Budget approaching, the talk of securing and ensuring ease of transaction in
                                Central Bank Digital Currencies (CBDCs) is further gaining ground.</p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://businessindia.co/magazine/protecttai-unveils-plans-to-fight-mobile-frauds-and-cyber-threats"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/business_india.webp"
                                alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent">
                            <h6>Protectt.ai unveils plans to fight mobile frauds and cyber threats</h6>
                            <!-- <p class="newsdate">sep 19, 2022</p> -->
                            <p>Manish Mimani is a man on a mission. On the eve of Republic Day 2023, Mimani is unveiling
                                his latest initiative, ‘Protectech’. </p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://www.financialexpress.com/industry/technology/protectt-ai-keeping-your-mobile-data-secure-from-cyberthreats/2672717/"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/financial.webp" alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent medianewsheading">
                            <h6>Protectt.ai: Keeping Your Mobile Data Secure From Cyberthreats</h6>
                            <!-- <p class="newsdate">sep 19, 2022</p> -->
                            <p>Protectt.ai has developed a plug-and-play security component which can be
                                integrated
                                with mobile apps and by default it</p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://timesofindia.indiatimes.com/blogs/voices/seven-steps-towards-safe-secured-banking-app-usage/"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/times_of_india.webp"
                                alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent">
                            <h6>Seven Steps Towards Safe & Secured Banking App Usage</h6>
                            <!-- <p class="newsdate">sep 7, 2022</p> -->
                            <p>Manish Mimani, Founder and CEO of Protectt.ai, shares important insights about
                                “Seven
                                steps towards safe & secured banking app usage”</p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://www.expresscomputer.in/guest-blogs/securing-digital-india-must-extend-to-mobile-devices/89820/"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/express.webp" alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent">
                            <h6>Securing Digital India Must Extend to Mobile Devices</h6>
                            <!-- <p class="newsdate">sep 9, 2022</p> -->
                            <p>India’s ambitious objective of reaching the US$1 trillion digital economy must be
                                carefully nurtured with a strong foundation of trust</p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://bankingfrontiers.com/protectt-ai-building-an-aatmanirbhar-bharat-with-industry-first-innovation-in-mobile-app-device-and-transaction-security/"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/banking_front.webp"
                                alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent">
                            <h6>Protectt.ai – Building an AatmaNirbhar Bharat With Industry First Innovation
                            </h6>
                            <!-- <p class="newsdate">sep 8, 2022</p> -->
                            <p>Here is a list of 10 important features a CISO would desire from a mobile
                                security
                                solution standpoint.</p>
                        </div>
                    </div>
                </a>
            </div>
        </div>


        <div class="row mt-30">
            <div class="col-md-12 text-center mb-30">
                <h4><a routerLink="/media">More News &#8594;</a></h4>
            </div>
        </div>
    </div>
</section>

<div class="modal fade" id="playLandingVideo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-md w-98vh" role="document">
        <div class="modal-content m-0 p-0 h-98vh position-relative" *ngIf="videoUrl != ''">
            <button type="button" class="btn position-top-right" data-dismiss="modal" aria-label="Close">
                <span style="color: #fff" aria-hidden="true">X</span>
            </button>
            <!-- <object data="{{getMainContentTrusted(videoUrl)}}" width="500" height="200"></object> -->
            <iframe id="video1landing" [src]='getMainContentTrusted(videoUrl)' width="100%" height="100%"
                frameborder="0" allowtransparency="true" webkitallowfullscreen mozallowfullscreen allowfullscreen
                allow="autoplay">
            </iframe>
        </div>
    </div>
</div>